<template>
<!-- 进口对账单 -->
  <div class="import-statement-list">
    <ab-list-query :tabs='tabs' @handleTabs="handleTabs">
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input
                         
                        placeholder="对账单号"
                        v-model.trim="formSearch.number"
                        clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-select   placeholder="回款状态" v-model="formSearch.returnStatus" @change="searchForm" clearable>
                        <el-option
                      v-for="(option, idx) in options.returnStatusList"
                      :key="idx"
                      :label="option.desc"
                      :value="option.value"
                    ></el-option>
                    </el-select>
                </el-col>
                 <el-col :span="4">
                    <el-select   placeholder="发票类型" v-model="formSearch.bizType" @change="searchForm" clearable>
                        <el-option
                            v-for="(option, idx) in [{desc: '13%增值税专用发票', value: '01'}, {desc: '海关税票+6% 服务费发票', value: '02'}]"
                            :key="idx"
                            :label="option.desc"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        class="searchBox"
                        startSrc="对账周期起"
                        endSrc="对账周期止"
                        v-model="formSearch.customsData"
                        @searchEvent="periodTimeChange"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm" >搜索</el-button>
                    <el-button link class="btn-svg" @click="resetForm"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
        </template>

        <template #toolbar>
            <el-button type="primary" @click="exportFile" :loading="btnLoading">导出</el-button>
            <el-button :loading="btnLoading" @click="deriveExcel" :disabled="printDis">打印对账单</el-button>
        </template>

        <template #table>
            <ab-table
                class="materialTable"
                ref="table"
                stripe
                showEdit
                showSelection
                showMoreEdit
                selectionWidth="45"
                indexWidth="50"
                widths="180"
                isFilter="operator"
                :filterArry="['备注']"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="isloading"
                @filterColumns="filterColumns"
                :handleSelectionChange="selectionChange"
            >
                <template #number="props">
                    <span class="number-primary" @click="getDetail(props.row)">{{ props.row.number }}</span>
                </template>

               <template #operator='scope'>
                    <el-button type="primary" link @click="getDetail(scope.row)">详情</el-button>
                </template>
               <template #moreOper="scope">
                    <el-button
                    size="mini"
                    type="text"
                    v-if="scope.row.status == '3'"
                    @click="goInvoic"
                    class="is-link"
                    >开票</el-button>
                    <el-button
                        size="mini"
                        class="is-link"
                        type="text"
                        @click="handlerFileView(scope.row)"
                        :disabled="!scope.row.isUpload"
                        :loading="isDownLoad"
                    >附件</el-button>
                    <el-button
                        size="mini"
                        type="text"
                        class="is-link"
                        @click="handlerPrepayment(scope.row)"
                        :disabled="scope.row.hasSetPrepayment || scope.row.waitReturnAmount == 0 || scope.row.statusDesc != '客户已确认'"
                    >提前还款</el-button>
               </template>
               <template #returnStatusDesc='scope'>
                    <div>
                        <span :class="getStatusClass(scope.row.returnStatusDesc)"></span>
                        {{ scope.row.returnStatusDesc }}
                    </div>
               </template>
                <template #statusDesc='scope'>
                    <div>
                        <span :class="getStatusClass(scope.row.statusDesc)"></span>
                        {{ scope.row.statusDesc }}
                    </div>
               </template>
               <template #bizTypeDesc="scope">
                    <span v-if="scope.row.bizType == '01'">13%增值税专用发票</span>
                    <span v-if="scope.row.bizType == '02'">海关税票+6% 服务费发票</span>
               </template>
            </ab-table>
            
        </template>

        <template #page>
            <ab-page
                :pageTotal="pages.total" 
                :currentPage='pages.currentPage' 
                :pageSize="pages.pageSize" 
                :pageSizes="pages.pageSizes"
                @searchForm="pageSearch"
            ></ab-page>
        </template>
    </ab-list-query>
    <ab-fileView v-model="fileView"></ab-fileView>
  </div>
</template>

<script>
export default {
    name: 'import-statement-list',
    data() {
        return {
            btnLoading: false,
            isloading: false,
            formSearch:{},
            options: {},
            tabs: [
                {name: '全部', value: '', state: ''},
                {name: '待确认', value: '', state: '2'},
                {name: '已确认', value: '', state: '3'},
            ],
            columns: [
                {
                    props: 'number',
                    labels: '对账单号',
                    widths: 150, 
                    slot:'slot'
                },
                {
                    props: 'settleArDate',
                    labels: '到期时间',
                    widths: 120
                },
                {
                    props: 'returnStatusDesc',
                    labels: '回款状态',
                    widths: 120, 
                    slot:'slot'
                },
                {
                    props: 'statusDesc',
                    labels: '对账状态',
                    widths: 120,
                    slot:'slot'
                },
                {
                    props: 'periodTimeRegion',
                    labels: '对账周期',
                    widths: 200,
                },
                {
                    props: 'agreedWayDesc',
                    labels: '账期类型',
                    widths: 80
                },
                {
                    props: 'currentBalanceAmountStr',
                    labels: '期末应付',
                    widths: 130,                
                    align:'right' 
                },
            
                {
                    props: 'currentAddBalanceAmount',
                    labels: '本期新增',
                    widths: 120,
                    type:'money',                    
                    align:'right' 
                },
                {
                    props: 'waitReturnAmount',
                    labels: '本期待回',
                    widths: 120,
                    type:'money',                    
                    align:'right' 
                },
                {
                    props: 'taxAgencyAmount',
                    labels: '税代费',
                    widths: 120,
                    type:'money',                    
                    align:'right' 
                },
                {
                    props: 'incidentalAmount',
                    labels: '杂费',
                    widths: 120,
                    type:'money',                    
                    align:'right' 
                },
                {
                    props: 'advancePaymentAmount',
                    labels: '垫付货款',
                    widths: 120,
                    type:'money',                    
                    align:'right' 
                },
                {
                    props: 'bizTypeDesc',
                    labels: '发票类型',
                    widths: 200,
                    slot: 'slot'
                },
                {
                    props: 'remark',
                    labels: '备注',
                    widths: 120,
                },
            ],
            tableData: [
                
            ],
            pages: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            multiSelected: [],
            fileView: {
                sourceBillType: 'ImportAccounts',
                sourceBillId: '',
                sourceBillNumber: '',
                show: false,
                items: [{'title': '对账单', attachType: '010'}]
            },
            isDownLoad: false
        }
    },
    computed: {
        printDis () {
            if (!this.multiSelected.length) {
                return true
            }
            for (let row of this.multiSelected) {
                if (row.principalId !== this.multiSelected[0].principalId || row.bizType !== this.multiSelected[0].bizType || row.trusteeId !== this.multiSelected[0].trusteeId) {
                return true
                }
            }
            return false
        }
    },
    mounted () {
        this.getSelectList()
    },
    activated() {
        this.searchForm(this.pages, this.$route.query.onece)
    },
    methods:{
         getStatusClass(val) {
            let cls = "";
            switch (val) {
                case "待回款":
                case "未回款":
                    cls = "status-13227A";
                break;
                case "部分回款":
                    cls = "status-FF8400";
                break;
                case "已回款":
                    cls = "status-0AB2A8";
                break;
                case "已逾期":
                    cls = "status-E21010";
                break;
                case "待确认":
                case "待客户确认":
                    cls = "status-E21010";
                break;
                case "已确认":
                    cls = "status-0AB2A8";
                break;
            }
            return cls;
        },
        pageSearch(obj) {
            this.pages.currentPage = obj.currentPage
            this.pages.pageSize = obj.pageSize
            this.searchForm()
        },
        //筛选列表字段
        filterColumns(array) {
            this.columns = array;
        },
        getDetail(row){
            this.$router.push({
                path:'import-statement-detail',
                query:{id: row.id, cache: false}
            })
        },
        getSelectList () {
            this.$get('/sms/importAccounts/getDDL').then(({ data }) => {
                if (data && data.code === 'C0000') {
                data.result.statusList = data.result.statusList.filter(e => e.desc !== '')
                this.options = data.result
                } else {
                this.options = {}
                }
            })
        },
        // 对账周期
        periodTimeChange (obj) {
            if (obj) {
                this.formSearch.periodTimeQueryFrom = obj[0]
                this.formSearch.periodTimeQueryTo = obj[1]
            } else {
                this.formSearch.periodTimeQueryFrom = ''
                this.formSearch.periodTimeQueryTo = ''
            }
            this.searchForm()
        },
        searchForm (pages, onece) {
            if (pages) {
                this.pages.currentPage = pages.currentPage
                this.pages.pageSize = pages.pageSize
            }
            let params = Object.assign({}, { data: this.formSearch }, { pageNum: this.pages.currentPage, pageSize: this.pages.pageSize })
            params.data.isEmptyContent = this.notEmpty ? false : undefined
            params.sortName = this.sortName
            params.order = this.order
            this.isloading = true
            this.$post('/sms/client/importAccounts/clientPageList', params, this, 'tableLoading').then(({ data }) => {
                if (data && data.code === 'C0000') {
                if (onece) {
                    let obj = {}
                    data.result.list.forEach(ele => {
                        if(ele.id == onece) {
                            obj = ele
                        }
                    })
                    this.tableData = [obj]
                } else {
                    this.tableData = data.result.list
                }
                    this.pages.total = data.result.total
                    this.tabs.map(e => {
                        if (e.name == '待确认') {
                            e.value = data.extra && data.extra.waitCount || ''
                        }
                    })
                } else {
                    this.tableData = []
                    this.pages.total = 0
                }
            }).finally(() => {
                this.isloading = false
            })
        },
        resetForm () {
            this.formSearch = {}
        },
        exportFile () {
            this.btnLoading = true
            let excelField = this.columns.map(e => e.props)
            let params = Object.assign({}, { data: this.formSearch, excelField: excelField, colTitleMapList: this.columns })
            params.data.isEmptyContent = this.notEmpty ? false : undefined
            this.$post('/sms/client/importAccounts/deriveList', params).then(({ data }) => {
                if (data && data.code === 'C0000') {
                // 创建隐藏的可下载链接
                var eleLink = document.createElement('a')
                eleLink.download = ''
                eleLink.target = '_blank'
                eleLink.style.display = 'none'
                // 字符内容转变成blob地址
                eleLink.href = data.message
                // 触发点击
                document.body.appendChild(eleLink)
                eleLink.click()
                // 然后移除
                document.body.removeChild(eleLink)
                }
            }).finally(() => {
                this.btnLoading = false
            })
        },
        selectionChange (array) {
            this.multiSelected = array
        },
        deriveExcel () {
            this.btnLoading = true
            this.$get('/sms/importAccounts/deriveMultiDataExcel', { idList: this.multiSelected.map(e => e.id).join(',') }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.target = '_blank'
                    eleLink.style.display = 'none'
                    // 字符内容转变成blob地址
                    eleLink.href = data.message
                    // 触发点击
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    // 然后移除
                    document.body.removeChild(eleLink)
                }
                this.btnLoading = false
            })
        },
        handleTabs (item) {
            this.formSearch.status =  item
            this.pages.currentPage = 1
            this.searchForm(this.pages)
        },
        goInvoic () {
            this.$router.push(
                {
                path: '/invoice-list',
                    query: {
                        activeName: 'wait'
                    }
                }
            )
        },
        handlerFileView (row) {
            this.fileView.sourceBillId = row.id
            this.fileView.sourceBillNumber = row.number
            this.isDownLoad = true
             this.$post("/oms/billAttach/queryBySourceData", {
                sourceBillType: this.fileView.sourceBillType,
                sourceBillId: this.fileView.sourceBillId
            }).then(({data}) => {
                console.log(data)
                let fileData = data.result || {}
                let fileList = []
                this.fileView.items.map(e => {
                    if (fileData[e.attachType]) {
                        fileList = fileList.concat(fileData[e.attachType])
                    }
                })
                this.downloadFile(fileList)
            }).catch (() => {
                this.isDownLoad = false
            }) 
        },
        downloadFile (fileList) {
            this.$post('/oms/billAttach/compress',
                { listData: fileList}
            ).then((res) => {
                if (res && res.data.result && res.data.code === 'C0000') {
                    this.$message({
                        type: 'success',
                        message: '下载成功！'
                    })
                    let eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.style.display = 'none'
                    // 字符内容转变成blob地址
                    eleLink.href = res.data.result
                    // 触发点击
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    // 然后移除
                    document.body.removeChild(eleLink)
                }
            }).finally(() => {
                this.isDownLoad = false
            })
        },
        handlerPrepayment(row) {
            this.$confirm('是否确定提前还款', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$get('/sms/importAccounts/setPrepayment', {id: row.id})
                .then(({ data }) => {
                if (data && data.code === 'C0000') {
                    this.searchForm()
                    this.$message.success(data.message)
                }
                })
            })
        },
    }
}

</script>

<style lang='scss'>
.import-statement-list{
    .el-table__body-wrapper{        
        .el-table__body{
            .el-button.el-button--text.is-link.el-tooltip__trigger{
                margin: 3px 30px 0px 0px !important;
            }
        }
    }
}
</style>